import fetch from "isomorphic-fetch";

import { withAccountAuthHeaders, withURLParam } from "./apiHelpers";
import { apiConf } from "./index";

export type GetInvoicesParams = {
    startDate?: string;
    endDate?: string;
};
export type GetInvoicesResponse = {
    firstPaymentDate: string;
    invoices: Invoice[];
};

export type Invoice = {
    id: string;
    referenceNumber: string;
    type: string;
    sideInvoiceUrl: string;
    amount: number;
    currency: string;
    createdAt: string;
    weekStartDate: string;
    weekEndDate: string;
    paid?: any;
};
export async function getInvoices(params: GetInvoicesParams): Promise<GetInvoicesResponse> {
    try {
        const res = await fetch(
            withAccountAuthHeaders(
                withURLParam(`${apiConf.BACK_URL}/v1/organisations/invoices`, {
                    startDate: params.startDate || "",
                    endDate: params.endDate || "",
                }),
            ),
        );
        return res.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
}
